/**
 * Deep clone using the native structuredClone API.
 *
 * structuredClone handles plain objects, arrays, Date, Map, Set, ArrayBuffer,
 * and more — everything we need for CardsState and AppState cloning.
 * It's significantly faster than a manual recursive clone with for...in.
 */
export function deepClone<T>(obj: T): T {
    return structuredClone(obj)
}
